<div class="marketplace-popup-container">
  <div class="dialog-header">
    <h2>{{ 'fleetsError.notification' | translate }}</h2>
    <button class="close-button" (click)="closeDialog()">&times;</button>
  </div>
  <div class="marketplace-popup-content">
    <div class="message-container">
      <h3>{{ 'fleetsError.noMarketplace' | translate }}</h3>
    </div>
    <div class="actions">
      <button class="action-button" (click)="closeDialog()">{{ 'close' | translate }}</button>
    </div>
  </div>
</div> 